export class ProcessoDocumento {

  public Id: number;
  public UsuarioNome: string;
  public ProcessoId: number;
  public ArquivoNome: string;

  public Data: string;
  public Usuario: string;
  public TipoMovimentacaoId: number;
  public Documento: string;

  public DocumentoDescricao: string;
  public SomenteDesdeProcesso: boolean;
  public TipoDocumentoId: number;
  public Descricao: string;
  public Extensao: string;
  public UsuarioId: number;
  public Subcategoria: string;
  public SubcategoriaId: number;

  constructor(init?: Partial<ProcessoDocumento>){
    Object.assign(this, init);
  }

}
